import { AlertCircle } from 'lucide-react'

interface LoadErrorStateProps {
  message: string
  description?: string
  onRetry: () => void
  retrying?: boolean
}

export function LoadErrorState({
  message,
  description = 'Check your connection and try again.',
  onRetry,
  retrying = false,
}: LoadErrorStateProps): JSX.Element {
  return (
    <div className="flex flex-col items-center justify-center gap-3 rounded-lg border border-gray-200 bg-white py-16 px-6 text-center">
      <AlertCircle size={32} className="text-red-500" aria-hidden="true" />
      <p className="text-sm font-semibold text-gray-900">{message}</p>
      <p className="max-w-sm text-[13px] text-gray-500">{description}</p>
      <button
        type="button"
        onClick={onRetry}
        disabled={retrying}
        className="mt-2 rounded-lg bg-gray-900 px-4 py-2 text-[13px] font-medium text-white transition-opacity hover:opacity-80 disabled:opacity-50"
      >
        {retrying ? 'Retrying…' : 'Try again'}
      </button>
    </div>
  )
}
